import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ContestParticipateData, ContestParticipateResponse } from '../lib/api/Contests';

import { useApi } from '../contexts/ApiContext';
import { updateAuthUser } from './useAuth';

export function useContestParticipate() {
    const api = useApi();
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutationResult } = useMutation<
        ContestParticipateResponse,
        Error,
        ContestParticipateData & { id: string }
    >({
        mutationFn: ({ id, ...data }) => api.contests.participate(id, data),
        onSuccess: (response) => {
            const { user: newUser = response } = response;
            updateAuthUser(queryClient, newUser as User);
        },
    });

    return {
        participate: mutate,
        participateAsync: mutateAsync,
        ...mutationResult,
    };
}
